<template>
  <div class="flex min-h-screen items-center justify-center p-6 text-center">
    <div>
      <h1 class="text-2xl font-semibold mb-2">Redirecting…</h1>
      <p class="text-gray-600">If nothing happens, <a :href="fallbackUrl" class="text-blue-600 underline">click here</a>.</p>
    </div>
  </div>

</template>

<script lang="ts">
import { defineComponent, onMounted, computed } from 'vue';
import * as amplitude from '@amplitude/analytics-browser';

function isAndroid(ua: string): boolean {
  return /Android/i.test(ua);
}

function isIOS(ua: string): boolean {
  return /iPhone|iPad|iPod/i.test(ua);
}

function isMobile(ua: string): boolean {
  return isAndroid(ua) || isIOS(ua) || /Mobile|Tablet|Phone/i.test(ua);
}

export default defineComponent({
  name: 'StoreRedirect',
  setup() {
    const userAgent = navigator.userAgent || navigator.vendor || (window as unknown as { opera?: string }).opera || '';

    const appStoreUrl = 'https://apps.apple.com/us/app/talab-ultimate-student-app/id6503147995';
    const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.talabapp.talab&hl=en_GB';
    const websiteUrl = `${window.location.origin}/`;

    const targetUrl = computed(() => {
      if (isIOS(userAgent)) return appStoreUrl;
      if (isAndroid(userAgent)) return playStoreUrl;
      if (isMobile(userAgent)) return playStoreUrl; // default mobile -> Play Store if unknown
      return websiteUrl;
    });

    const deviceType = computed(() => {
      if (isIOS(userAgent)) return 'ios';
      if (isAndroid(userAgent)) return 'android';
      if (isMobile(userAgent)) return 'mobile-other';
      return 'desktop';
    });

    const fallbackUrl = computed(() => targetUrl.value);

    onMounted(async () => {
      try {
        amplitude.track('download_redirect', {
          device: deviceType.value,
          target_url: targetUrl.value,
          path: window.location.pathname,
          query: window.location.search,
          referrer: document.referrer || '',
        });
        await amplitude.flush();
      } catch (e) {
        // ignore tracking errors
      }
      setTimeout(() => {
        window.location.replace(targetUrl.value);
      }, 50);
    });

    return { fallbackUrl };
  },
});
</script>

<style scoped>
</style>
